import { RegexConst } from "@app/shared/constants/regex.constant";
import {
  Component,
  OnInit,
  Input,
  Output,
  EventEmitter,
  TemplateRef,
  ViewChild,
  ChangeDetectorRef, // 1. Import ViewChild
} from "@angular/core";
import { BsModalService, BsModalRef } from "ngx-bootstrap";
import { ValidationMessageService } from "@app/shared/services/validation-message/validation-message.service";
import { ToastrMessageService } from "@app/shared/services/toastr-message/toastr-message.service";
import { FormBuilder, FormGroup, Validators } from "@angular/forms";
import { ResetPasswordService } from "./services/reset-password.service";

@Component({
  selector: "crm-password-reset-modal",
  templateUrl: "./password-reset-modal.component.html",
  styleUrls: ["./password-reset-modal.component.scss"],
})
export class PasswordResetModalComponent implements OnInit {
  @Input() type: string = "add";
  @Input() buttonName: string;
  @Input() modalTitle: string;
  @Input() formValid: boolean;
  @Input() user_id: any;
  @Output() onSubmit = new EventEmitter();
  fileForm: FormGroup;
  newPasswordType: string = "password";
  regex = RegexConst;

  // 2. Add this ViewChild. This gets the <ng-template #ModalRef> from your HTML file.
  @ViewChild("ModalRef", { static: false }) ModalRef: TemplateRef<any>;

  modalRef: BsModalRef; // This is for the *opened* modal instance

  // modal config to unhide modal when clicked outside
  config = {
    backdrop: true,
    ignoreBackdropClick: true,
  };

  constructor(
    private modalService: BsModalService,
    private validationMessageService: ValidationMessageService,
    private toastrMessage: ToastrMessageService,
    private fb: FormBuilder,
    private cdr: ChangeDetectorRef,
    private _ResetPasswordService: ResetPasswordService,
  ) {}

  ngOnInit() {
    this.buildFilesForm();
  }

  openModal(template: TemplateRef<any>) {
    this.modalRef = this.modalService.show(template, this.config);
  }

  public show() {
    // 3. This is the fix.
    // Call openModal with the TEMPLATE (this.ModalRef),
    // not the INSTANCE (this.modalRef).
    this.openModal(this.ModalRef);
  }
  buildFilesForm() {
    this.fileForm = this.fb.group({
      new_password: [
        "",
        [Validators.required, Validators.pattern(this.regex.PASSWORD)],
      ],
    });
  }
  onSave(): void {
    //this.onSubmit.emit(true);

    // if (this.formValid) {
    //   // to hide the red border on form field
    //   this.validationMessageService.formSubmitted = false;
    //   this.modalRef.hide();
    // }

    if (this.fileForm.valid) {
      const formData = new FormData();
      Object.keys(this.fileForm.controls).forEach((key) => {
        const control = this.fileForm.get(key);
        formData.append(key, control.value);
      });
      formData.append("user_id", this.user_id);
      this.createFilesLog(formData);
    }
  }
  createFilesLog(formData) {
    this._ResetPasswordService.userResetPassword(formData).subscribe(
      (response) => {
        console.log("response for the Files logs :", response);
        if (response.success === true || response.success === "true") {
          this.toastrMessage.showSuccess(
            response.message || "Password reset successfully!",
          );
          this.resetFilesForm();
          this.modalRef.hide();
          this.cdr.detectChanges();
        } else {
          this.toastrMessage.showError(response.message);
        }
      },
      (err: any) => {
        console.log(err || err.errors);
        this.toastrMessage.showError(err || err.errors);
      },
    );
  }
  onCancel(): void {
    // to hide the red border on form field
    this.resetFilesForm();
    this.validationMessageService.formSubmitted = false;
    this.modalRef.hide();
  }

  //  the toggle method for password
  toggleNewPassword(): void {
    this.newPasswordType =
      this.newPasswordType === "password" ? "text" : "password";
  }

  // clear form
  resetFilesForm() {
    this.fileForm.reset();

    this.validationMessageService.formSubmitted = false;
  }
}
